<template lang="pug">
  div
    div(v-if='($route.name!="CruisesHistoricDashboard") && (typeData !== "alerta") && (dataKpis && dataKpis.entityType !== "panelParking")')
      ods-select.map-tools__item(
        v-model='kpiFilterSelected'
        multiple
        collapse-tags
        @change='categoriesChangeKpi'
      )
        ods-option(
          v-for='item in kpiFilterByCategories'
          :key='item.value'
          :label='item.label'
          :value='item.value')
    template(v-if='dataKpis')
      template(v-if='typeData === "alerta"')
        ods-row.sc-kpi__row.kpiAlert(
            type='flex'
          )
            ods-col.sc-kpi__col(
              :span='24'
            )
              div.kpi-title-content
                div.kpi-title {{ dataKpis.name}}
                ods-tag(type='secondary') {{ $t(dataKpis.subtype) }}
              p.kpi-subTitle {{ dataKpis.description }}
              p.kpi-date {{ dataKpis.date }}
      template(v-else)
        template(v-if='dataKpis.type && dataKpis.entityType === "panelParking"')
          template( v-for='(rowKpi, index) in dataKpis.values')
            transition(name='slide-fade' appear mode="out-in")
              ods-row.sc-kpi__row(
                type='flex'
                :style="{ transition: 'transform 0.4s ' + (index*0.2) + 's' }"
                class="kpiPanelParking"
              )
                ods-col.sc-kpi__col(
                  :span='24'
                )
                  div.kpi-title-content
                    //-img(:src='iconSelected')
                    //- div.custom-icon
                    //-   i(:class='iconSelected')
                    div.kpi-title {{ $t(rowKpi.direction) }}
                    ods-tag(type='secondary') {{ $t(dataKpis.entityType) }}
                  ods-col.sc-kpi__col(
                    :span='12'
                  )
                    div
                    ods-kpi(
                      :ammount='formatLocaleNumber(rowKpi.freeSpots)'
                    )
                      span(slot='title') {{ $t('Plazas Libres') }}
                  ods-col.sc-kpi__col(
                    :span='12'
                  )
                    div
                    ods-kpi(
                      :ammount='formatLocaleNumber(rowKpi.value)'
                    )
                      span(slot='title') {{ $t('Prob. Aparcamiento') }}
        template(v-else)
          template(v-for='(rowKpi, index) in dataKpis')
            transition(v-if='rowKpi.show' name='slide-fade' appear mode="out-in")
              template(v-if='((rowKpi.entityType === "busStop") && (interval==="1d")) || (rowKpi.entityType === "fleet")')
                ods-col.sc-kpi__col.kpiIndividual(
                  :span='12'
                  :style="{ transition: 'transform 0.4s ' + (index*0.2) + 's' }"
                )
                  ods-row.sc-kpi__row(
                    :class='rowKpi.measureType === titleKpiSelected ? "actived" : ""'
                    type='flex'
                    @click.native.prevent="showChartBykpi(rowKpi)"
                  )
                    ods-col.sc-kpi__col(
                      :span='24'
                    )
                      div.kpi-title-content
                        ods-tag(v-if='rowKpi.entityType != "fleet"' type='secondary') {{ $t(rowKpi.entityType) }}
                        div.kpi-title {{ $t(rowKpi.measureType) }}
                      ods-col.sc-kpi__col(
                        :span='24'
                      )
                        div
                        ods-kpi(
                          :ammount='formatLocaleNumber(rowKpi.kpiMaxValue)'
                          :unit='$t(rowKpi.kpiUnit)'
                        )
                      ods-icon.expandChart(name="chart-line" size="20")
              template(v-else-if='(rowKpi.entityType === "solicitations") || (rowKpi.entityType === "citizens") || (rowKpi.entityType === "consultations") || (rowKpi.entityType === "complaints") || (rowKpi.entityType === "damage") || (rowKpi.entityType === "suggestions")')
                ods-col.sc-kpi__col.kpiIndividual(
                  :span='12'
                  :style="{ transition: 'transform 0.4s ' + (index*0.2) + 's' }"
                )
                  ods-row.sc-kpi__row(
                    :class='rowKpi.measureType === titleKpiSelected ? "actived" : ""'
                    type='flex'
                    @click.native.prevent="showChartBykpi(rowKpi)"
                  )
                    ods-col.sc-kpi__col(
                      :span='24'
                    )
                      div.kpi-title-content
                        // ods-tag(type='secondary' ) {{ $t(rowKpi.entityType) }}
                        div.kpi-title {{ $t(rowKpi.measureType) }}
                      ods-col.sc-kpi__col(
                        :span='24'
                      )
                        div
                        ods-kpi(
                          :percentage='(rowKpi.kpiTrendMaxValue === "up" ? -1 : (rowKpi.kpiTrendMaxValue === "down" ? 1 : null))'
                          :ammount='formatLocaleNumber(rowKpi.kpiMaxValue)'
                          :unit='$t(rowKpi.kpiUnit)'
                          triangle=''
                          :class='(rowKpi.kpiTrendMaxValue === "down" && rowKpi.measureType === "solicitations") ? "kpiTrendUp" : "kpiTrenDown"'
                        )
                          // span(slot='title') {{ $t('maximum') }}
                      ods-icon.expandChart(name="chart-line" size="20")
              template(v-else)
                ods-row.sc-kpi__row(
                  type='flex'
                  @click.native.prevent="showChartBykpi(rowKpi)"
                  :style="{ transition: 'transform 0.4s ' + (index*0.2) + 's' }"
                  v-if="rowKpi.measureType !== 'totalBikes'"
                )
                  ods-col.sc-kpi__col(
                    :span='24'
                  )
                    div.kpi-title-content
                      div.kpi-title {{ $t(rowKpi.measureType) }}
                      ods-tag(type='secondary'  v-if='($route.name=="MobilityAndTransportMain") || ($route.name=="CruisesRealTimeDashboard") || ($route.name=="EnvironmentDashboard") || ($route.name=="ParksAndGardensDashboard")') {{ $t(rowKpi.entityType) }}
                      ods-tag(type='secondary' v-else) {{ $t(tagType) }} -
                    ods-col.sc-kpi__col(
                      :span='12'
                    )
                      div
                      ods-kpi(
                        :ammount='formatLocaleNumber(rowKpi.kpiMaxValue)'
                        :unit='$t(rowKpi.kpiUnit)'
                        :percentage='(rowKpi.kpiTrendMaxValue === "up" ? 1 : (rowKpi.kpiTrendMaxValue === "down" ? -1 : null))'
                        triangle=''
                        :class='(rowKpi.kpiMaxValue > 100 && rowKpi.measureType === "o3") ? "umbral" : "sin_umbral"'
                      )
                        span(slot='title') {{ $t('maximum') }}
                    ods-col.sc-kpi__col(
                      :span='12'
                    )
                      div
                      ods-kpi(
                        :ammount='formatLocaleNumber(rowKpi.kpiMinValue)'
                        :unit='$t(rowKpi.kpiUnit)'
                        :percentage='(rowKpi.kpiTrendMinValue === "up" ? 1 : (rowKpi.kpiTrendMinValue === "down" ? -1 : null))'
                        triangle=''
                        :class='(rowKpi.kpiMinValue > 100 && rowKpi.measureType === "o3") ? "umbral" : "sin_umbral"'
                        v-if="$route.name != 'CRM'"
                      )
                        span(slot='title') {{ $t('minimum') }}
                    ods-icon.expandChart(name="chart-line" size="20")
  </template>

<script>
import mapChartsElements from '@/mixins/mapChartsElements'

export default {
  name: 'KpiVertical',
  data () {
    return {
      kpiFilterSelected: ['all']
    }
  },
  computed: {
    kpiFilterByCategories: {
      get: function () {
        if (this.dataKpis) {
          var arr = []
          var arrFil = []
          for (let i = 0; i < this.dataKpis.length; i++) {
            arr.push(this.dataKpis[i].measureType)
          }
          arr.unshift('all')
          var arrUnique = arr.filter(function (elem, index, self) {
            return index === self.indexOf(elem)
          })
          for (let i = 0; i < arrUnique.length; i++) {
            if (arrUnique[i] === 'totalBikes') {
              arrUnique.splice(i, 1)
            } else {
              var obj = {}
              obj.value = arrUnique[i]
              obj.label = this.$t(arrUnique[i]).toLowerCase()
              obj.label = obj.label[0].toUpperCase() + obj.label.slice(1)
              arrFil.push(obj)
            }
          }
          return arrFil
        }
      },
      set: function (newValue) {
        return newValue
      }
    }
  },
  props: {
    dataKpis: {
    //  type: Array
    },
    iconSelected: {
      type: String
    },
    titleKpiSelected: {
      type: String
    },
    typeData: {
      type: String
    },
    tagType: {
      type: String
    },
    interval: {
      type: String
    }
  },
  mixins: [ mapChartsElements ],
  methods: {
    showChartBykpi (kpi) {
      this.$emit('showChartBykpi', kpi)
    },
    categoriesChangeKpi (category) {
      for (let i = 0; i < this.dataKpis.length; i++) {
        this.dataKpis[i].show = false
        for (let j = 0; j < category.length; j++) {
          if (this.dataKpis[i].measureType === category[j]) {
            this.dataKpis[i].show = true
          }
          if (category[j] === 'all') {
            this.dataKpis[i].show = true
          }
        }
      }
    }
  },
  mounted () {
    // console.log("ey estoy montando")
    this.kpiFilterByCategories = []
    // this.categoriesChangeKpi()
  },
  updated () {
  }
}
</script>

<style lang="scss">
.sc-dashboard__kpis__content{
  .ods-select {
    margin-bottom: rem(16);
  }
  .ods-input__inner{
    background-color: #FFF !important;
  }
}
</style>
<style scoped lang="scss">
  .sc-dashboard__kpis__content{
      .kpiAlert{
        border: 1px solid $--color-white;
        min-height: 131px;
        width: 100%;
        /* &:hover, &.actived{
          border:  1px solid $--color-white;
        } */
      }
      .kpiPanelParking {
        border: 1px solid $--color-white !important;
        cursor: initial !important;
      }
      .sc-kpi__row {
        background: $--color-white;
        border-radius: rem(4);
        border: 1px solid $--color-white;
        box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
        margin: 0 0 rem(16);
        padding: rem(16);
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover, &.actived{
          border: 1px solid $--color-primary;
        }
        .kpi-title-content {
          align-items: start;
          display: flex;
          justify-content: space-between;
          margin-bottom: rem(12);
          img {
            vertical-align: middle;
            margin-right: rem(16);
            width: rem(30);
          }
        }
        .kpi-title{
          font-size: rem(10);
          text-transform: uppercase;
          font-weight: 500;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .kpi-subTitle{
          margin-top: rem(16);
          font-size: rem(12);
          line-height: rem(24);
          font-weight: normal;
          text-transform: initial;
          margin-bottom: rem(12);
        }
        .kpi-hour, .kpi-date{
          color: $--color--grey-medium;
          font-size: rem(12);
          font-weight: normal;
          line-height: rem(24);
          margin-top: rem(16);
          text-align: right;
          text-transform: initial;
        }
        .iconBackgroundAlert {
          //background-color: $--color-danger;
          display: inline-block;
          padding: rem(8);
          border-radius: 100%;
          //margin-right: rem(16);
          // i {
          //   color: $--color-white;
          // }
        }
      }
      .expandChart {
        position: absolute;
        bottom: rem(16);
        right: rem(16);
        padding: rem(4);
        z-index: 4;
        margin: 0;
        color: $--color--grey-medium;
      }
      .kpiIndividual{
        margin-bottom: rem(8);
        width: calc(50% - 0.25rem);
        &:nth-child(even) {
          margin-right: rem(4);
        }
        &:nth-child(odd) {
          margin-left: rem(4);
        }
        .kpi-title-content {
          display: initial;
        }
        .kpi-title {
          display: block;
          margin-bottom: 16px;
        }
        .ods-tag.ods-tag--secondary{
          margin-bottom: 16px;
        }
        /deep/ .ods-kpi--no-href .ods-kpi__list {
          min-height: unset;
        }
        /deep/ .kpiTrenDown{
          .ods-kpi__list {
            display: flex;
            justify-items: center;
            align-items: center;
            .ods-kpi__number{
              justify-items: flex-end;
              order: 2;
            }
            .positive{
              margin-right: rem(10);
              order: 1;
              color: $--color-green;
              .triangle{
                .icon{
                  transform: rotate(180deg);
                  path{
                    stroke: $--color-green;
                    fill: $--color-green;
                  }
                }
              }
              .percentage{
                display: none;
              }
            }
            .negative{
              margin-right: rem(10);
              order: 1;
              .triangle{
                .icon{
                  transform: rotate(180deg);
                  path{
                    stroke: $--color-red;
                    fill: $--color-red;
                  }
                }
              }
              .percentage{
                display: none;
              }
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/KpiVertical.vue